import React, { useRef, useMemo } from "react";
import JoditEditor from "jodit-react";

const EditorJSSingle = ({ content, setContent }) => {
  const editor = useRef(null);
  const contentRef = useRef(content); // keep latest typing

  const config = useMemo(
    () => ({
      readonly: false,
      placeholder: "Start typing...",
      height: 400,
      toolbarAdaptive: false,
      resizeToMinHeight: false,
    }),
    []
  );

  return (
    <JoditEditor
      ref={editor}
      value={content}
      config={config}
      tabIndex={1}
      onChange={(val) => {
        contentRef.current = val; // store current typing
      }}
      onBlur={() => {
        setContent(contentRef.current); // update FormData only when user leaves editor
      }}
    />
  );
};

export default EditorJSSingle;
